import { IContext } from "./IContext";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { LogGroup , CreateElement , SetStyles , Log, Scale } from ".././MyHelpers";
import { Settings } from "../Settings";
import {  MyVideo } from "../MyVideo"

// this class contains shared videos, that can be played by any game
export interface ISharedVideoContext extends IContext
{
    AddVideo(videoResource: MyVideo): MyVideo;
    GetVideo(resid: ResourceIdentifier): MyVideo;

    // Show(resid: ResourceIdentifier): void;
    // Hide(resid: ResourceIdentifier): void;
}

export interface VideoSettings
{
    restartOnPlay?: boolean;
}

export  class SharedVideoContainer
{

    protected view: HTMLElement;
    protected resid: ResourceIdentifier;
    protected logGroup: LogGroup;

    protected videos: Map<string, MyVideo> = new Map<string, MyVideo>();

    public constructor(resid: ResourceIdentifier, logGroup: LogGroup) {
        this.resid = resid.Add("SharedVideoContainer");
        this.logGroup = logGroup.Add("SharedVideoContainer");
        this.view = CreateElement("div", {
            classes: [this.resid.ID()], style: {
                position: "absolute",
                //top: "0px",
                //left: "0px",
                //display : "flex",
                //width: (Settings.Screens * Settings.ScreenWidth) + "px",
                //height: Settings.ScreenHeight + "px",

                pointerEvents: "none",
            }
        });

        if (this.resid.Scope().match("ScreenAll-SharedVideoWallDisplay")) {
            SetStyles(this.view, {
                width: (Settings.Screens * Settings.ScreenWidth) + "px",
                height: Settings.ScreenHeight + "px",

            });

        }
        else if (this.resid.Scope().match("ScreenAll-SharedVideoGame")) {
            SetStyles(this.view, {
                width: Settings.ScreenWidth + "px",
                height: (Settings.Screens * Settings.ScreenHeight) + "px",
                top : Scale.Ypx(0),        
                position : "absolute",
            });
        }
}

    public AddVideo(videoResource: MyVideo): MyVideo
    {
        let existingVideoResource: MyVideo = this.videos.get(videoResource.Name());
        if (existingVideoResource)
        {
            // Log.Debug(this.logGroup, "Video " + videoResource.Name() + " exists!");
        }
        else
        {
            existingVideoResource = videoResource;
            if (this.resid.Scope().match("ScreenAll-SharedVideoWallDisplay")) {
            SetStyles(videoResource.View(), {
                //width:  "100%",
                //height:  "100%",
    
            });
            }
            else if (this.resid.Scope().match("ScreenAll-SharedVideoGame")) {
                SetStyles(videoResource.View(), {
                    width:  "100%",
                    //height:  "100%",
        
                });
            }
            this.videos.set(videoResource.Name(), videoResource);
            this.view.append(videoResource.View());
            this.InternalHideVideo(videoResource.View());
        }

        return existingVideoResource;
    }

    public GetVideo(resid: ResourceIdentifier): MyVideo
    {
        let videoResource: MyVideo = this.videos.get(resid.ID());
        if (!videoResource)
        {
            Log.Error(this.logGroup, "Trying to get video " + resid.ID() + ", but it does not exist!");
        }

        return videoResource;
    }

    public View(): HTMLElement
    {
        return this.view;
    }

    public ShowVideo(resid: ResourceIdentifier): void
    {
        let videoResource = this.videos.get(resid.ID());
        if (!videoResource)
        {
            Log.Error(this.logGroup, "Error showing video " + resid.ID() + ", it does not exist");
        }
        else
        {
            this.InternalShowVideo(videoResource.View());
        }
    }

    public HideVideo(resid: ResourceIdentifier): void
    {
        let videoResource = this.videos.get(resid.ID());
        if (!videoResource)
        {
            Log.Error(this.logGroup, "Error hiding video " + resid.ID() + ", it does not exist");
        }
        else
        {
            this.InternalHideVideo(videoResource.View());
        }
    }


    protected InternalShowVideo(videoElement: HTMLElement)
    {
        videoElement.style.display = "";
    }

    protected InternalHideVideo(videoElement: HTMLElement)
    {
        videoElement.style.display = "none";
    }

    public StopVideo(resid: ResourceIdentifier): void
    {

    }

    public RestartVideo(resid: ResourceIdentifier): void
    {

    }
}

export class SharedVideoContext implements ISharedVideoContext
{
    protected enabled: boolean = false;

    protected resid: ResourceIdentifier;
    protected logGroup: LogGroup;

    protected sharedVideoContainer: SharedVideoContainer;

    protected videoResources: Map<string, MyVideo> = new Map<string, MyVideo>();

    public constructor(resid: ResourceIdentifier, logGroup: LogGroup, sharedVideoContainer: SharedVideoContainer)
    {
        this.resid = resid;
        this.logGroup = logGroup;

        this.sharedVideoContainer = sharedVideoContainer;
    }

    public AddVideo(videoResource: MyVideo): MyVideo
    {
        // TODO in case style is set, check that the style is matching with the existing. The same video can't have two different styles
        this.sharedVideoContainer?.AddVideo(videoResource);
        this.videoResources.set(videoResource.Name(), videoResource);

        return videoResource;
    }

    public GetVideo(resid: ResourceIdentifier): MyVideo
    {
        // can only get videos that were added, and not from the global space
        return this.videoResources.get(resid.ID());
    }

    public Name(): string
    {
        return this.resid.ID();
    }

    public Enable(): void
    {
        if (!this.enabled)
        {
            this.enabled = true;
        }
    }

    public Disable(): void
    {
        if (this.enabled)
        {
            this.enabled = false;
        }

        // TODO stop all videos
        this.videoResources.forEach((videoResource) => {
            videoResource.StopAndReset(this.resid);
        });
    }
 
    public Running(): boolean
    {
        return this.enabled;
    }
}